import axios from "axios";
import { getUser, logOutUser, getLocalKey, setReturnURL } from '../utils/commonfunction';
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "./Constants";
import Cookies from "js-cookie";

const Axios = (options = {}) => {
  const baseURL = process.env.REACT_APP_API_URL;

  const rawLang = getLocalKey('system_language') ? getLocalKey('system_language') : 'en';
  const cleanLang = typeof rawLang === 'string' ? rawLang.replace(/[^\x00-\xFF]/g, '').trim() : 'en';
  
  const csrfToken = Cookies.get('_csrf');
  let headers = {
    language: cleanLang,
    ...(csrfToken ? { 'x-csrf-token': csrfToken } : {})
  };

  const cleanToken = (token) => {
    if (typeof token !== 'string') return '';
    return token.replace(/[^\x00-\xFF]/g, '').trim();
  };

  try {
    const roleKey = options?.role || 'super_admin';
    const userData = getUser(roleKey);
    
    if (userData && userData.token) {
      headers.Authorization = `Bearer ${cleanToken(userData.token)}`;
    } else {
      // Fallback: try to get token directly using getLocalKey for production or raw localStorage
      const directData = getLocalKey(roleKey) || localStorage.getItem(roleKey);
      if (directData) {
        try {
          const parsed = typeof directData === 'string' ? JSON.parse(directData) : directData;
          if (parsed && parsed.token) {
            headers.Authorization = `Bearer ${cleanToken(parsed.token)}`;
          }
        } catch (e) {
          // Ignore invalid JSON in localStorage
        }
      }
    }
  } catch (err) {
    // Suppress error in production
  }

  const axiosInstance = axios.create({
    baseURL: `${baseURL}/webservice/api/v1`,
    headers
  });

  axiosInstance.interceptors.request.use((config) => {
    const latestCsrf = Cookies.get('_csrf');
    if (latestCsrf) {
      config.headers['x-csrf-token'] = latestCsrf;
    }
    return config;
  }, (err) => Promise.reject(err));

  axiosInstance.interceptors.response.use((response) =>
    new Promise((resolve) => {
      if (response.config && response.config.responseType === "blob") {
        resolve({
          data: response.data,
          headers: response.headers,
          status: response.status
        });
      } else {
        resolve(response.data);
      }
    }), (error) => {
      if (error && error.response && error.response.status && error.response.status === 401 && error?.response?.data?.error?.clearSession) {
        setReturnURL(options?.role);
        logOutUser(options?.role);
        Swal.fire({
          icon: "error",
          text: (error?.response?.data?.message) || "Something went wrong, Please try again later.",
          ...SWAL_SETTINGS,
        });
      } else if(error && error.response && error.response.status && error.response.status === 401) {
        Swal.fire({
          icon: "error",
          text: (error?.response?.data?.message) || "Something went wrong, Please try again later.",
          ...SWAL_SETTINGS,
        });
      }
      return Promise.reject(error.response?.data || error);
    }
  );

  return axiosInstance;
};

export default Axios;